import React from 'react';
import { observer } from 'mobx-react';
let DelayRender = (props) => {
	return props.test ? <div> {props.children} </div> : <div></div>
}
export default observer(DelayRender);


// WEBPACK FOOTER //
// ./src/app/components/Common/DelayRender.js